import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import { PAGE_NAME, SUBMIT_COMPLETE_API, CA_SUBMIT_API, APPLICATION_STATUS } from '../../config/GBConstants';
import { REDIRECT_SUFFIX, NETWORK, FLOW_TYPE } from '../../../framework/App/AppConstants';
import setUrl from '../../../framework/App/SetUrl';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { APPROVAL_POPUP_CLOSE, APPROVAL_POPUP_SHOW, DIRECT_DEBIT_ERROR_SHOW } from './CAPageConstants';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { redirectFlowAction } from '../../../framework/store/RedirectFlow/RedirectFlowActions';
import { buildCapeTxnRunner } from '../../../framework/App/CapeTransaction';

const runGbEsignCapeTxn = buildCapeTxnRunner('gb_esign');

export const showDirectDebitError = () => ({
    type: DIRECT_DEBIT_ERROR_SHOW,
    payload: true
});

export const handleRedirect = (response, serverData) => {
    if (_.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect, serverData);
        return true;
    }
    return false;
};

export const submitContractAgreement = (data) => (dispatch, getState) => {
    return runGbEsignCapeTxn(() => {
        const { serverData = {} } = getState();
        const { flow, _csrf = '' } = serverData;

        if (data.agreeToReadCredit) {
            data.agreeToReadContract = 'acceptedCreditAgreement';
        }

        if (data.agreeToReadSecci) {
            data.agreeToReadSECCI = 'acceptedSecci';
        }

        return axios
            .request({
                url: CA_SUBMIT_API,
                method: 'post',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            })
            .then(response => {
                if (_.get(response, 'data.validationErrors.errors')) {
                    //Server-side validation handling
                } else if (response.data.showCompletePopup) {
                    dispatch(setServerData({showCompletePopup: _.get(response, 'data.showCompletePopup'),
                        showMarketingConsent: _.get(response, 'data.showMarketingConsent'),
                        wallet: _.get(response, 'data.wallet')
                    }));
                    dispatch(push(PAGE_NAME.CA_PAGE));
                } else {
                    const applicationStatus = _.get(response, 'data.applicationStatus');
                    if ((flow === FLOW_TYPE.TESLA || flow === FLOW_TYPE.VENICE) && (applicationStatus === APPLICATION_STATUS.APPROVED)) {
                        dispatch(setServerData({decisionModel: {applicationStatus}}));
                        dispatch(push(PAGE_NAME.DECISION_PAGE));
                    } else {
                        dispatch(redirectFlowAction(REDIRECT_SUFFIX.RETURN_REDIRECT));
                        return;
                    }
                }
                dispatch(spinnerClose());
            })
            .catch(error => {
                capeLog && capeLog('response:error, GB_CAPageActions,' + (error && error.message));
                if (handleRedirect(error && error.response, serverData)) {
                    return;
                }

                if (_.get(error, 'response.data.err', false)) {
                    dispatch(setServerData({errorModel: _.get(error, 'response.data', {})}));
                    dispatch(push(PAGE_NAME.ERROR_PAGE));
                    dispatch(spinnerClose());
                } else {
                    // should never be here
                    capeLog && capeLog('response:error: unexpected error response for SECCI Submit API');
                }
            });
    });
};

export const submitCompleteForm = data => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;

    return axios
        .request({
            url: SUBMIT_COMPLETE_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(response => {
            if (response && _.get(response, 'data.result')) {
                return dispatch(redirectFlowAction(REDIRECT_SUFFIX.RETURN_REDIRECT));
            } else {
                dispatch(spinnerClose());
                dispatch(showDirectDebitError());
            }
        })
        .catch(error => {
            //Added for testing direct debit error with dev route.
            dispatch(showDirectDebitError());
            dispatch(spinnerClose());
        });
};

export const approvalPopupShow = () => ({
    type: APPROVAL_POPUP_SHOW
});

export const approvalPopupClose = () => ({
    type: APPROVAL_POPUP_CLOSE
});
